import Popup from "devextreme-react/popup";
import UploadHoursForm from "../../../Components/UploadHoursForm/uploadHoursForm";
import { isMobile } from "../../../Utils/media-query";

export default function HoursPopups({ hoursData, userId, onClose }) {
  // this function allows the mui popper to be selected,
  // but allows the mui popper to be clicked without closed
  // ask phoenix for more information
  const hideOnOutsideClick = (e) => {
    const popperElement = document.getElementById("popper");
    if (popperElement?.contains(e.target)) {
      return false;
    }
    return true;
  };

  return (
    <Popup
      visible={true}
      width="auto"
      height="auto"
      //fullScreen={isMobile} //need close button first to implement this
      hideOnOutsideClick={hideOnOutsideClick}
      onHiding={() => {
        onClose();
      }}
      showTitle={false}
    >
      <UploadHoursForm
        parentData={hoursData.formData}
        userId={userId}
        onClose={onClose}
      />
    </Popup>
  );
}
